import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { Button } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { useConnectBasket } from "../../hooks/useConnectBasket";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
/** Кнопка подключения */
export var ConnectButton = function ConnectButton(_ref) {
  var basketPayload = _ref.basketPayload,
    text = _ref.text,
    reachGoal = _ref.reachGoal;
  var _useConnectBasket = useConnectBasket({
      basketPayload: basketPayload
    }),
    isLoading = _useConnectBasket.isLoading,
    onConnect = _useConnectBasket.onConnect;
  var handleClickWithMetric = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (typeof window !== 'undefined' && window.ym) {
              // Todo: Надо адаптирвоать кнопку для метрики через автометрику
              window.ym(26001372, 'reachGoal', reachGoal);
            }
            _context.next = 3;
            return onConnect();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleClickWithMetric() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: cx('button'),
    "data-t-id": "components-ConnectButton"
  }, /*#__PURE__*/React.createElement(Button, {
    loading: isLoading,
    onClick: handleClickWithMetric,
    size: "m"
  }, text));
};